import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  videoTitle: {
    color: '#515B6A',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginTop: 0,
  },
  video: {
    maxWidth: '100%',
    cursor: 'pointer',
  },
  selectVideoWrapper: {
    '& [data-small-image]': {
      display: 'none',
    },
  },
  previewContainer: {
    height: 'fit-content',
    border: 'dashed #DCDEE5 2px',
    minHeight: 186,
  },
}), { name: 'VideoInstruction' });

export default useStyles;
